import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps, mapLanguageToMoment } from 'i18n'
import DatePicker from 'react-datepicker'
import moment from 'moment-timezone'
import { formatDate } from 'utils/date'
import 'react-datepicker/dist/react-datepicker.css'
import { Icon } from 'components/styled/icon'
import { InputStyle } from 'components/form-components/styled-text-input'

const propTypes = {
  language: PropTypes.string.isRequired,
  timezone: PropTypes.string,
  placeholderText: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
}

const defaultProps = {
  value: undefined,
  timezone: undefined,
}

export const DatePickerContainer = styled.div`
  ${InputStyle};

  .react-datepicker {
    font-size: 1em !important;
    border-radius: 0;
  }

  .date-picker-input {
    height: 4rem;
    line-height: 4rem;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .react-datepicker-popper {
    &[data-placement^='bottom'] {
      margin-top: 0;
    }

    &[data-placement^='top'] {
      margin-bottom: 0;
    }
  }

  .icon.icon-calendar {
    height: 1.9rem;
    width: 1.9rem;
    margin-top: 0px;
    margin-right: 4px;
    margin-left: -1px;
  }

  .react-datepicker__input-container {
    text-align: center;
  }

  .react-datepicker__triangle {
    left: 30%;
  }

  .react-datepicker-popper {
    z-index: 100;
  }

  .react-datepicker__year-read-view {
    font-weight: bold;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    border-radius: 0;

    &:hover {
      border-radius: 0;
    }
  }

  .react-datepicker__header {
    padding-top: 0.8em !important;
  }
  .react-datepicker__month {
    margin: 0.4em 1em !important;
  }
  .react-datepicker__day-name,
  .react-datepicker__day {
    width: 1.9em !important;
    line-height: 1.9em !important;
    margin: 0.166em !important;
  }
  .react-datepicker__current-month {
    font-size: 1em !important;
  }
  .react-datepicker__navigation {
    top: 1em !important;
    line-height: 1.7em !important;
    border: 0.45em solid transparent !important;
  }
  .react-datepicker__navigation--previous {
    border-right-color: ${({ theme }) => theme.color.grey90} !important;
    left: 1em !important;
  }
  .react-datepicker__navigation--next {
    border-left-color: ${({ theme }) => theme.color.grey90} !important;
    right: 1em !important;
  }

  .react-datepicker__input-container {
    width: 100%;
    background-color: ${({ theme }) => theme.color.primary07};
  }
  .react-datepicker__header {
    background-color: ${({ theme }) => theme.color.primary07};
  }
  .react-datepicker__day--selected {
    background-color: ${({ theme }) => theme.color.primary110};

    &:hover {
      background-color: ${({ theme }) => theme.color.primary120};
    }
  }
`

const DateContainer = styled.div`
  padding-left: ${({ theme }) => theme.space.s8};
`

function onChangeDate(
  value,
  onChange,
  initialValue,
  timezone,
  endOfDay,
  startOfDay
) {
  let date
  const end = moment.tz(value, timezone).endOf('day')
  const start = moment.tz(value, timezone).startOf('day')
  if (!initialValue && (endOfDay || startOfDay)) {
    date = endOfDay ? end : start
  } else {
    date = value
  }
  onChange(date)
}

export function DatepickerInput(props) {
  const formattedDate = formatDate(props.value, props.timezone)
  return (
    <DatePickerContainer>
      <DatePicker
        {...props}
        locale={mapLanguageToMoment(props.language)}
        allowSameDay
        className="date-picker-input"
        fixedHeight
        value={formattedDate}
        selected={moment.tz(props.value, props.timezone)}
        onChange={value =>
          onChangeDate(
            value,
            props.onChange,
            props.value,
            props.timezone,
            props.endOfDay,
            props.startOfDay
          )
        }
        showYearDropdown
        dateFormatCalendar="MMMM"
        autoComplete="off"
        customInput={
          <div className="trigger" readOnly>
            <Icon type="date_range" size="s20" />
            <DateContainer>
              {formattedDate || props.placeholderText}
            </DateContainer>
          </div>
        }
      />
    </DatePickerContainer>
  )
}

DatepickerInput.propTypes = propTypes
DatepickerInput.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(DatepickerInput)
